import { render, staticRenderFns } from "./TrainingDialogTabsTires.vue?vue&type=template&id=6586c538&"
import script from "./TrainingDialogTabsTires.vue?vue&type=script&lang=js&"
export * from "./TrainingDialogTabsTires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports